import { render, staticRenderFns } from "./resule.vue?vue&type=template&id=33068c7c&"
import script from "./resule.vue?vue&type=script&lang=js&"
export * from "./resule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports